import React from "react";
import axios from "axios";
import { useDispatch } from 'react-redux';
import { UnoStoreHooks, UiComponents } from "@simulanisindia/ui";
import { useNavigate } from "react-router-dom";
const { useUnoSelector } = UnoStoreHooks;

const { Header: UIHeader } = UiComponents;

const Header = ({ sideBar, setSideBar }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = useUnoSelector((state) => state.user);

  // const handleLogout = async () => {
  //   try {
  //     await axios.post(
  //       `${configData.config.UNO_URL}/api/auth/logout`,
  //       {},
  //       {
  //         headers: {
  //           Authorization: `Bearer ${userData?.token}`,
  //         },
  //       }
  //     );
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     localStorage.removeItem("token");
  //     dispatch(removeUserData());
  //     navigate(`/`);
  //   }
  // };

  const handleLogout = () =>{
    window.location.reload();
  }

  const logoAndNameClick = () =>{
    navigate(`/dashboard/directories`);
  }

  return (
    <>
      {/* <header>
        <div className="sidetoggle">
          <div
            className={sideBar ? "ps-1 activebar sidesvgdiv" : " sidesvgdiv ps-1"}
            onClick={() => {
              setSideBar(!sideBar);
              if (sideBar) {
                document.body.classList.add("body-lock");
              } else {
                document.body.classList.remove("body-lock");
              }
            }}
            style={{ width: "25px", height: "25px" }}
          >
            <SideNav />
          </div>
          <div className="mainlogo LOGOHERE">
            <img src={defaultLogo} referrerPolicy={"no-referrer"} alt="" />
         
            <p>Channel Management </p>
          </div>
        </div>
        <div className="leftmain">
          <div className="profile">
            <div className="dropdown profileavatar">

              <p className="d-none d-md-block">{userData?.user?.name}</p>
              <button
                className="btn btn-secondary dropdown-toggle themetoggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <div className="useravatar">
                  <div className="avatar-placeholder">{userData?.user?.avatar}</div>
                </div>
              </button>

              <div className="dropdown-menu themehere popupon">
                <div className="profilemenuhead" tabIndex="0">
                  <div className="avatar-placeholder">UN</div>
                  <div className="profilemenudata">
                    <p>{userData?.user?.name}</p>
                    <p>{userData?.user?.email}</p>
                  </div>
             
                </div>
                <p className="logoutbtn">Log out</p>
          
              </div>
            </div>

            <div className="dropdown profileavatar appnavigator">
              <button
                className="btn btn-secondary dropdown-toggle themetoggle "
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <SimApps />
              </button>

             
            </div>
          </div>
        </div>
      </header> */}

      <UIHeader
        appLogo={null}
        showSearch={false}
        showDrawer={false}
        showThemeSwitch={false}
        logoutHandler={handleLogout}
        appName="Home"
        logoAndNameClick={logoAndNameClick}
        // profileLinks={[
        //   {
        //     handleManageProfileClick: () => handleClickProfileLink({ url: `/manage/account/${userData?.user.uuid}` }),
        //     label: "Manage Your Account",
        //   },
        // ]}
      />
    </>
  );
};

export default Header;
